/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ex_TitleInputs */

const en_formatter_ex_title = /** @type {(inputs: Formatter_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting a minified response`)
};

const ko_formatter_ex_title = /** @type {(inputs: Formatter_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축된 응답 포매팅하기`)
};

const ja_formatter_ex_title = /** @type {(inputs: Formatter_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮されたレスポンスを整形する`)
};

/**
* | output |
* | --- |
* | "Formatting a minified response" |
*
* @param {Formatter_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ex_title = /** @type {((inputs?: Formatter_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ex_title(inputs)
	if (locale === "ko") return ko_formatter_ex_title(inputs)
	return ja_formatter_ex_title(inputs)
});